module.exports = __webpack_public_path__ + "img/CompletionGift1.bf9901ec.png";